import React, { Component } from 'react';
import { FastField } from 'formik';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import GenerateYears from '../../transforms/GenerateYears';

class Birthday extends Component {
  constructor(props) {
    super(props);

    this.state = {
      years: GenerateYears(100),
      focused: false,
    };
  }

  render() {
    return (
      <FastField name={this.props.name}>
        {({ field, form }) => (
          <div className="form-group">
            <label>{this.props.label}</label>
            <SingleDatePicker
              date={form.values[field.name]}
              onDateChange={e => form.setFieldValue(field.name, e)}
              focused={this.state.focused}
              block
              placeholder="01/01/1985"
              isOutsideRange={() => false}
              onFocusChange={({ focused }) => {
                this.setState({ focused });
                form.setFieldTouched(field.name, true);
              }}
              numberOfMonths={1}
              renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '-4px',
                }}
                >
                  <div>
                    <select
                      className="month-select"
                      value={month.month()}
                      onChange={(e) => {
                        onMonthSelect(month, e.target.value);
                      }}
                    >
                      {moment.months()
                        .map((label, value) => (
                          <option key={label} value={value}>{label}</option>
                        ))}
                    </select>
                  </div>
                  <div>
                    <select
                      className="year-select"
                      value={month.year()}
                      onChange={(e) => {
                        onYearSelect(month, e.target.value);
                      }}
                    >
                      {this.state.years.map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              id={field.name}
            />
            {form.touched[field.name] && form.errors[field.name] && (
              <span
                className="input-text-error-msg"
              >{form.errors[field.name] || this.props.error}
              </span>
            )}
          </div>
        )}
      </FastField>
    );
  }
}

export default Birthday;



// WEBPACK FOOTER //
// ./src/components/Birthday/index.js